module.exports = __webpack_public_path__ + "assets/img/4.2e9561b5.png";